<template>
  <div
    id="init-home-container"
    class="d-flex flex-column"
    style="width: 100; height: 100dvh"
  >
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!--<auth></auth>-->

    <v-main>
      <template>
        <div class="text-center">
          <v-dialog v-model="dialog" width="500">
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                Upload 1 File
              </v-card-title>

              <v-card-text>
                <v-file-input
                  ref="fileinput"
                  show-size
                  truncate-length="30"
                  label="Select File"
                  @change="selectFile"
                ></v-file-input>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="black" class="white--text" @click="hide_dialog"
                  >Cancel</v-btn
                >
                <v-btn color="primary" text @click="upload_now">
                  Upload Now
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
      <v-form v-model="valid" ref="form">
        <v-container
          class="whitesmoke black--text"
          id="home-container"
          style="max-width: 768px"
        >
          <div id="header_container" class="d-flex flex-row justify-start ml-4">
            <div id="badge_host" style="width: 10%; height: auto">
              <img
                src="../images/gold-badge-320.png"
                alt="badge"
                style="width: 100%; height: auto"
              />
            </div>
            <v-spacer></v-spacer>

            <div
              id="case_num_cont"
              class="d-flex flex-row justify-start casenum"
            >
              <label id="lbl_caseno" style="color: black; font-weight: 600"
                >CASE&nbsp;NO</label
              >
              <v-text-field
                id="casenum"
                dense
                required
                :rules="nameReq"
                class="ml-2 mb-3"
                v-mask="'##-######'"
                maxlength="10"
                v-model="formIn.case_num"
              >
              </v-text-field>
            </div>
          </div>
          <div
            id="form_title"
            class="d-flex flex-column justify-center align-center"
            style="width: 100%"
          >
            <div class="text-h6">RENO POLICE DEPARTMENT</div>
            <div class="text-subtitle2 text-md-h5 font-weight-bold">
              CITIZEN'S PROPERTY RELEASE REQUEST
            </div>
          </div>
          <div class="text-h6 mt-3">INSTRUCTIONS</div>
          <p>Please fill out this request.</p>
          <p>
            RPD will contact you when your property is ready to be picked up.
            You must make an appointment for a specific date and time, Monday
            through Thursday (excluding holidays) between 8:00 am and 4:00 pm to
            pick up your property. You must bring identification ( a valid
            driver's license is preferred) - Requesting Person will need a
            notarized letter or POA.
          </p>

          <v-row dense>
            <v-col cols="12" class="font-weight-black"
              >Requesting Person:</v-col
            >
          </v-row>
          <v-row dense class="pa-0 ma-0">
            <v-col cols="12" md="6">
              <v-text-field
                label="Requesting Person Date of Birth"
                v-model="formIn.dob"
                type="date"
                min="1910-01-01"
                :rules="nameReq"
                aria-required
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                label="SSN"
                v-model="formIn.ssn"
                maxlength="11"
                v-mask="'###-##-####'"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="pa-0 ma-0">
            <v-col cols="12" md="4">
              <v-text-field
                label="First"
                v-model="formIn.first"
                maxlength="60"
                :rules="nameReq"
                aria-required
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                label="Last"
                v-model="formIn.last"
                maxlength="60"
                :rules="nameRules"
                aria-required
                required
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                label="Middle"
                v-model="formIn.mddl"
                maxlength="60"
              ></v-text-field
            ></v-col>
          </v-row>

          <v-row dense class="pa-0 ma-0">
            <v-col cols="12" md="6">
              <v-text-field
                label="Email"
                v-model="formIn.email"
                maxlength="60"
                :rules="emailRules"
                aria-required
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Phone"
                v-model="formIn.phone"
                maxlength="14"
                v-mask="'(###) ###-####'"
                placeholder="(###) ###-####"
                :rules="nameReqEq14"
                aria-required
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="12">Mailing Address:</v-col>
          </v-row>
          <v-row dense class="pa-0 ma-0">
            <v-col cols="10">
              <v-text-field
                label="Street"
                v-model="formIn.street"
                maxlength="120"
                :rules="nameReq120"
                aria-required
                required
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Apt #"
                v-model="formIn.appt_num"
                maxlength="8"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="pa-0 ma-0">
            <v-col cols="6">
              <v-text-field
                label="City"
                v-model="formIn.city"
                maxlength="120"
                :rules="nameReq120"
                aria-required
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                attach
                v-model="formIn.state"
                :items="states"
                :item-text="'code'"
                :item-value="'code'"
                label="State"
                :rules="nameReq"
                aria-required
                required
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Zip"
                v-model="formIn.zip"
                maxlength="5"
                v-mask="'#####'"
                :rules="nameReqEq5"
                aria-required
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" class="font-weight-black">Owner:</v-col>
          </v-row>
          <v-row dense class="pa-0 ma-0">
            <v-col cols="12" md="4">
              <v-text-field
                label="First"
                v-model="formIn.req_first"
                maxlength="60"
                :rules="nameReq"
                aria-required
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                label="Last"
                v-model="formIn.req_last"
                maxlength="60"
                :rules="nameRules"
                aria-required
                required
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                label="Middle"
                v-model="formIn.req_mddl"
                maxlength="60"
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row dense class="pa-0 ma-0">
            If out of state, please provide the FedX Account number for the
            shipping fee.
          </v-row>
          <v-row dense class="pa-0 ma-0">
            <v-col cols="12">
              <v-text-field
                label="FedX Account"
                v-model="formIn.fedx"
                maxlength="120"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="pa-0 ma-0">
            <v-col cols="12">
              <v-textarea
                maxlength="8000"
                v-model="formIn.descr"
                outlined
                auto-grow
                counter
                label="Property Decription (8,000 Char.)"
                :rules="nameReq"
                aria-required
                required
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row dense class="pa-0 ma-0 mb-2">
            <v-col cols="12">
              <v-btn
                class="primary"
                style="width: 100%"
                @click="show_diag_files"
                >Upload Files</v-btn
              >
              <hr />
            </v-col>
          </v-row>

          <v-row
            dense
            class="pa-0 ma-0 mb-2"
            style="border: 1px solid black"
            v-if="lst_files.length > 0"
          >
            <v-col cols="12">
              <div id="lst_files">
                Files
                <span style="font-size: smaller">(click X to delete)</span>
              </div>
              <v-list dense>
                <v-list-item v-for="(item, i) in lst_files" :key="i">
                  <v-btn
                    icon
                    color="accent"
                    @click="del_upload(item.uploadfileId)"
                  >
                    <v-icon>$delete</v-icon>
                  </v-btn>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.filename }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <v-row dense class="pa-0 ma-0">
            <v-col cols="12">
              <v-btn v-if="show_submit" class="accent" @click="save"
                >Submit Form</v-btn
              >
            </v-col>
          </v-row>
          <!--<v-row dense class="pa-0 ma-0">
            <v-col cols="6">
              <v-btn v-if="show_submit" class="" @click="test_fill"
                >Test Fill</v-btn
              >
            </v-col>-->
            <!-- <v-col cols="6">
              <v-btn v-if="show_submit" class="" @click="test_print"
                >Test Print</v-btn
              >
            </v-col> -->
          <!--</v-row>-->
        </v-container>
      </v-form>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .casenum {
    width: 47%;
  }
  #lbl_caseno {
    font-size: 20px;
    position: relative;
    top: 3px;
  }
  #home-container {
    width: 100dvw;
    max-width: 100dvw;
    height: auto;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

@media (min-width: 768px) {
  .casenum {
    width: 25%;
  }
  .hide-if-small {
    display: flex !important;
  }
  //.hide-if-large {
  //   display: flex !important;
  // }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
// import xtabs from "./xtabs.vue";
//import auth from "./auth.vue";
//import addedit_diag from "./addedit_diag.vue";
//const add_edit = () => import("./add_edit.vue");

export default {
  name: "Home",
  // components: {
  //   auth,
  //   add_edit,
  //   search,
  //   recent,
  //   searchResults,
  // },
  components: {},
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      lst_files: [],
      currentFile: null,
      dialog: false,
      show_submit: false,
      propertyId: -1,
      formIn_full: {
        case_num: "11-11111",
        req_mddl: "Z",
        req_first: "BW",
        req_last: "Bra",
        mddl: "A",
        first: "Jack",
        last: "Whole",
        email: "emailtest@site.com",
        dob: "1963-11-01",
        ssn: "123-34-5678",
        street: "55 Oakme Cir.",
        appt_num: "4",
        city: "Reno",
        state: "NV",
        zip: "89436",
        descr: "Picnic Table. Green.",
        fedx: "fedx12345",
        phone: "(775) 733-9022",
      },
      formIn_new: {
        propertyId: 0,
        case_num: "",
        mddl: "",
        first: "",
        last: "",
        email: "",
        req_mddl: "",
        req_first: "",
        req_last: "",
        dob: "",
        ssn: "",
        street: "",
        appt_num: "",
        city: "Reno",
        state: "NV",
        zip: "",
        descr: "",
        fedx: "",
        phone: "",
      },
      formIn: {
        propertyId: 0,
        case_num: "",
        mddl: "",
        first: "",
        last: "",
        req_mddl: "",
        req_first: "",
        req_last: "",
        email: "",
        dob: "",
        ssn: "",
        street: "",
        appt_num: "",
        city: "Reno",
        state: "NV",
        zip: "",
        descr: "",
        fedx: "",
        phone: "",
      },
      valid: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      nameRules: [
        (v) => !!v || "This is required",
        (v) => v.length <= 60 || "Name must be less than 60 characters",
      ],
      nameReq120: [
        (v) => !!v || "This is required",
        (v) => v.length <= 120 || "Field must be less than 120 characters",
      ],
      nameReqEq5: [
        (v) => !!v || "This is required",
        (v) => v.length == 5 || "Field must equal 5 characters",
      ],
      nameReqEq14: [
        (v) => !!v || "This is required",
        (v) => v.length == 14 || "Field must equal 14 characters",
      ],
      nameReq: [(v) => !!v || "This is required"],
      states: [
        {
          name: "Alabama",
          code: "AL",
        },
        {
          name: "Alaska",
          code: "AK",
        },
        {
          name: "Arizona",
          code: "AZ",
        },
        {
          name: "Arkansas",
          code: "AR",
        },
        {
          name: "California",
          code: "CA",
        },
        {
          name: "Colorado",
          code: "CO",
        },
        {
          name: "Connecticut",
          code: "CT",
        },
        {
          name: "Delaware",
          code: "DE",
        },
        {
          name: "Florida",
          code: "FL",
        },
        {
          name: "Georgia",
          code: "GA",
        },
        {
          name: "Hawaii",
          code: "HI",
        },
        {
          name: "Idaho",
          code: "ID",
        },
        {
          name: "Illinois",
          code: "IL",
        },
        {
          name: "Indiana",
          code: "IN",
        },
        {
          name: "Iowa",
          code: "IA",
        },
        {
          name: "Kansas",
          code: "KS",
        },
        {
          name: "Kentucky",
          code: "KY",
        },
        {
          name: "Louisiana",
          code: "LA",
        },
        {
          name: "Maine",
          code: "ME",
        },
        {
          name: "Maryland",
          code: "MD",
        },
        {
          name: "Massachusetts",
          code: "MA",
        },
        {
          name: "Michigan",
          code: "MI",
        },
        {
          name: "Minnesota",
          code: "MN",
        },
        {
          name: "Mississippi",
          code: "MS",
        },
        {
          name: "Missouri",
          code: "MO",
        },
        {
          name: "Montana",
          code: "MT",
        },
        {
          name: "Nebraska",
          code: "NE",
        },
        {
          name: "Nevada",
          code: "NV",
        },
        {
          name: "New Hampshire",
          code: "NH",
        },
        {
          name: "New Jersey",
          code: "NJ",
        },
        {
          name: "New Mexico",
          code: "NM",
        },
        {
          name: "New York",
          code: "NY",
        },
        {
          name: "North Carolina",
          code: "NC",
        },
        {
          name: "North Dakota",
          code: "ND",
        },
        {
          name: "Ohio",
          code: "OH",
        },
        {
          name: "Oklahoma",
          code: "OK",
        },
        {
          name: "Oregon",
          code: "OR",
        },
        {
          name: "Pennsylvania",
          code: "PA",
        },
        {
          name: "Rhode Island",
          code: "RI",
        },
        {
          name: "South Carolina",
          code: "SC",
        },
        {
          name: "South Dakota",
          code: "SD",
        },
        {
          name: "Tennessee",
          code: "TN",
        },
        {
          name: "Texas",
          code: "TX",
        },
        {
          name: "Utah",
          code: "UT",
        },
        {
          name: "Vermont",
          code: "VT",
        },
        {
          name: "Virginia",
          code: "VA",
        },
        {
          name: "Washington",
          code: "WA",
        },
        {
          name: "West Virginia",
          code: "WV",
        },
        {
          name: "Wisconsin",
          code: "WI",
        },
        {
          name: "Wyoming",
          code: "WY",
        },
      ],
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
  },
  methods: {
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },
    test_print() {
      window.open("/print/?id=123454");
    },
    test_fill() {
      this.formIn = this.mno(this.formIn_full);
    },
    del_upload(id) {
      this.show_loader(true);
      console.log(id);
      let formIn = {};
      formIn.id = id;
      formIn.apiname = "del_upload";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.lst_files = self.mno(data);
          self.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("del_upload", msg, "error", null, null);
        });
    },
    upload_now() {
      this.show_loader(true);

      if (this.currentFile == "" || this.currentFile == null) {
        this.swall_it(
          "Error Upload File",
          "No file Selected",
          "warning",
          null,
          null
        );

        this.show_loader(false);
        return true;
      }
      let formData = new FormData();
      formData.append("file", this.currentFile);
      formData.append("propertyId", this.propertyId);

      //this.$refs.fileinput.value = null;
      this.currentFile = null;
      var self = this;

      this.$store
        .dispatch("uploadfile", formData)
        .then((data) => {
          self.lst_files = self.mno(data);
          self.show_loader(false);

          self.currentFile = null;
          self.$refs.fileinput.reset();
          this.dialog = false;
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Upload File", msg, "error", null, null);
        });
    },
    selectFile(file) {
      this.currentFile = file;
    },
    show_diag_files() {
      this.currentFile = null;
      this.dialog = true;
    },
    hide_dialog() {
      this.$refs.fileinput.reset();
      this.currentFile = null;
      this.dialog = false;
    },
    add_property() {
      // this.mrbreakpoint("add_p");
      let formIn = {};
      formIn = this.formIn;
      formIn.token = "none";
      formIn.dob = "1900-01-01";

      formIn.apiname = "add_property";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          // self.mrbreakpoint("id");
          console.log("propertyId: " + data.propertyId);
          self.formIn.propertyId = data.propertyId;
          self.propertyId = data.propertyId;
          self.formIn.dob = "0000-00-00";
          // DEV DEV
          self.$nextTick(() => {
            self.show_submit = true;
          });
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Adding", msg, "error", null, null);
        });
    },
    save() {
      this.mrbreakpoint("save");
      if (this.$refs.form.validate() == false) {
        this.swall_it(
          "Submit Status",
          "Some fields are incorrect. Please address the red fields before submitting.",
          "warning",
          null,
          null
        );
        return true;
      }
      this.show_loader(true);
      let formIn = {};
      formIn = this.formIn;
      formIn.propertyId = this.propertyId;
      formIn.token = "none";
      if (formIn.dob == "0000-00-00" || formIn.dob == null) {
        formIn.dob = "1900-01-01";
      }

      formIn.apiname = "save_property";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log("propertyId: " + data.propertyId);
          //self.formIn.propertyId = data.propertyId;
          self.$refs.form.reset();
          // self.$refs.fileinput.reset();
          self.add_property();

          self.lst_files = [];
          this.swall_it("Submit Status", "Success.", "success", null, null);
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    save_stat(stat_data) {
      console.log("stat_data: " + stat_data.arrest);
      this.save_stat_data = stat_data;

      if (parseInt(this.save_stat_data.stops) <= 0) {
        this.swall_it(
          "Save Status",
          "Stops must be greater than 0",
          "warning",
          null,
          null
        );
        return true;
      }

      this.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.frm_stat_data_cnts = stat_data;

      formIn.apiname = "save_stat";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.addedit_update_now = new Date();
          self.update_recent = new Date();
          self.edit_on = false;
          this.add_entry_title = "Add Entry";
          //open panel
          if (self.edit_from == "recent") {
            self.edit_from = "";

            self.add_entry_title = "Add Entry";
            this.addedit_update_now = new Date();
          }
          if (self.edit_from == "search") {
            self.edit_from = "search_updated";
            this.update_search_results = new Date();
            self.add_entry_title = "Add Entry";
            this.addedit_update_now = new Date();
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saveing", msg, "error", null, null);
        });
    },

    init(self) {
      this.show_loader(false);
    },
  },
  mounted() {
    this.add_property();
    // fake user login
    var user = {
      email: "jvonmolt@gmail.com",
      roles: "manymanyroles",
      token: "myverylongandencryptedtoken",
      rpduserId: 42,
      auth: true,
    };
    this.$store.commit("setUser", user);
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
